globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.Controllers.Websites.DesignsPropositionsSelectionController = (function(superClass)
{
  utils.extend(DesignsPropositionsSelectionController, superClass);

  function DesignsPropositionsSelectionController($html) {
    this.$html              = $html;
    this.$sliderWrapper     = $html.find(".design-propositions-slider");
    this.$slides            = this.$sliderWrapper.find(".design-proposition-wrapper")
    this.$thumbnailsWrapper = $html.find(".design-propositions-thumbnails-wrapper");
    this.$thumbnails        = this.$thumbnailsWrapper.find(".design-proposition-thumbnail");
    this.checkboxes         = this.$sliderWrapper.find('input[type="checkbox"]');
    this.$submitBtn         = this.$html.find('button[type="submit"]');
    this.$form              = this.$html.find(".content-wrapper form");
  }

  DesignsPropositionsSelectionController.prototype = {
    init: function() {
      var controller = this;

     appCustomerSpace.Loader().start();

      controller.toggleSubmitButton();
      controller.setSelectedDesignText();
      controller.beforeUnload();
      controller.submit();
      controller.initSlider();
      controller.initThumbnailsSelectors();
      controller.initCheckboxes();
    },
    initSlider: function() {
      var controller = this;

      controller.$sliderWrapper.on('init', function() {
        appCustomerSpace.Loader().stop();
        controller.$sliderWrapper.show();
        controller.$thumbnailsWrapper.show();
      })

      controller.$sliderWrapper.slick({
        dots: false,
        fade: true,
        speed: 100,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: "<button type='button' class='slick-prev'><i class='fa fa-chevron-left' aria-hidden='true'></i></button>",
        nextArrow: "<button type='button' class='slick-next'><i class='fa fa-chevron-right' aria-hidden='true'></i></button>",
      });


      controller.$sliderWrapper.on("afterChange", function(event, slick, currentSlide, nextSlide) {
        $thumbnail = controller.$html.find('.design-proposition-thumbnail[data-index=' + currentSlide + "]");

        if($thumbnail.length) {
          controller.setActiveThumbnail($thumbnail);
        }
      });

    },
    initThumbnailsSelectors: function() {
      var controller  = this;
      $(controller.$thumbnails[0]).addClass("active");

      $.each(controller.$thumbnails, function(index, thumb) {
        var $thumb = $(thumb);

        $thumb.on("click", function() {
          controller.setActiveThumbnail($thumb);
        })
      })
    },
    initCheckboxes: function() {
      var controller = this;

      appCustomerSpace.LimitlessPlugins.Checkbox.init(controller.$html);

      controller.checkboxes.on('change', function(){
        var checkbox = this;

        $toUncheck = controller.checkboxes.filter(function() {
          if((this != checkbox) && $(this).is(":checked")) {
            return $(this);
          }
        });

        if($toUncheck) {
          $toUncheck.prop('checked', false).uniform();
        }

        controller.toggleSubmitButton();
        controller.setSelectedDesignText();
      })
    },
    toggleSubmitButton: function() {
      var controller = this;

      if(controller.$sliderWrapper.find('input[type="checkbox"]:checked').length == 0) {
        controller.$submitBtn.prop("disabled", true).addClass("disabled");
      } else {
        controller.$submitBtn.prop("disabled", false).removeClass("disabled");
      }
    },
    setActiveThumbnail: function($thumbnail) {
      var controller = this,
          index = $thumbnail.data("index");

      $.each(controller.$thumbnails, function(index, thumb) {
        $(thumb).removeClass("active");
      })

      $thumbnail.addClass("active");
      controller.$sliderWrapper.slick('slickGoTo', index);
    },
    setSelectedDesignText: function() {
      var controller          = this,
          $selectedDesignText = controller.$html.find(".design-proposition-submit-text");
          $selectedInput      = controller.$sliderWrapper.find('input[type="checkbox"]:checked')

      if ($selectedInput.length) {
        $selectedDesignText.html("Vous avez selectionné la maquette " + $selectedInput.data("design-index"));
      } else {
        $selectedDesignText.html("Aucune maquette selectionnée");
      }
    },
    submit: function () {
      var controller = this;

      controller.$submitBtn.on("click", function() {
        $(window).off('beforeunload');
        appCustomerSpace.Loader().start();
        controller.$form.submit();
      })
    },
    beforeUnload: function() {
      $(window).bind('beforeunload', function(){
        return "Êtes-vous certain de quitter cette page ? Toutes vos modifications seront annulées.";
      });
    }
  }

  return DesignsPropositionsSelectionController;
})(appCustomerSpace.Controllers.MainController);
